document.addEventListener("DOMContentLoaded", () => {
  let hasShownThisSession = false;

  // ============== 1. ASSET REPOSITORY ==============
  const ICONS = {
    wings: `<svg viewBox="0 0 100 30" class="logo-wings"><path d="M50 5 L65 8 L85 8 L65 15 L50 12 Z M50 5 L35 8 L15 8 L35 15 L50 12 Z" fill="none" stroke="#bd5b0d" stroke-width="1"/><circle cx="50" cy="10" r="6" fill="#001b3a"/><path d="M48 10 L50 7 L52 10 L50 13 Z" fill="white"/></svg>`,
    pants: `<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke="currentColor"><path d="M8 3h8v18l-4-1.5-4 1.5V3z"/><path d="M12 3v15"/></svg>`,
    truck: `<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke="currentColor"><path d="M1 3h15v13H1V3zM16 8h4l3 3v5h-7V8z"/><circle cx="5" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>`,
    warn: `<svg viewBox="0 0 24 24" fill="none" stroke="#bd5b0d" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01"/></svg>`,
    tag: `<svg viewBox="0 0 24 24" fill="none" stroke="#225a2d" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><circle cx="7" cy="7" r="1"/></svg>`,
    shield: `<svg width="24" height="24" viewBox="0 0 24 24" fill="#001b3a"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 2.18l7 3.12v4.7c0 4.59-3.12 8.82-7 10-3.88-1.18-7-5.41-7-10v-4.7l7-3.12zM12 7l-2 3h1.5v6h1v-6h1.5l-2-3z"/></svg>`,
    arrow: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>`
  };

  // ============== 2. EXTERNAL RESOURCES ==============
  const setupDependencies = () => {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600&family=Inter:wght@300;400;500;600;700&display=swap';
    document.head.appendChild(fontLink);

    const style = document.createElement('style');
    style.innerHTML = `
      #fit-upsell-overlay * { box-sizing: border-box; -webkit-font-smoothing: antialiased; }
      #fit-upsell-overlay {
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0, 0, 0, 0.45); display: flex; align-items: center; justify-content: center;
        z-index: 2147483647; font-family: 'Inter', sans-serif; padding: 20px;
      }
      #fit-modal-container {
        background: #fdfbf7; border-radius: 12px; max-width: 1100px; width: 100%;
        position: relative; box-shadow: 0 30px 60px rgba(0,0,0,0.2);
        border: 1px solid #e5e7eb; padding: 50px 40px 30px 40px; color: #001b3a;
        max-height: 98vh; overflow-y: auto;
      }
      .fit-close { position: absolute; top: 20px; right: 25px; font-size: 32px; cursor: pointer; color: #111; line-height: 1; font-weight: 300; }
      .fit-header { text-align: center; margin-bottom: 14px; }
      .logo-wings { width: 120px; margin: 0 auto 10px; display: block; }
      .fit-header h1 { font-family: 'Playfair Display', serif !important; font-size: 56px !important; color: #001b3a !important; margin: 0 !important; text-transform: uppercase; letter-spacing: 4px; font-weight: 400 !important; line-height: 1.1 !important; }
      .fit-header .sub-h1 { font-family: 'Playfair Display', serif !important; font-size: 46px !important; color: #001b3a !important; margin: 0 0 10px 0 !important; text-transform: uppercase; letter-spacing: 4px; font-weight: 400 !important; line-height: 1.1 !important; }
      .trusted-row { display: flex; align-items: center; justify-content: center; gap: 15px; margin-top: 5px; color: #001b3a; font-size: 16px; font-weight: 500; font-family: 'Inter', sans-serif; }
      .trusted-row::before, .trusted-row::after { content: ""; height: 1px; width: 50px; background: #dcdcdc; }
      .g-star { color: #bd5b0d; font-size: 18px; }
      
      .fit-grid { display: flex; gap: 25px; margin-bottom: 35px; align-items: stretch; }
      .fit-card { flex: 1; background: #fff; border: 1px solid #eee; border-radius: 14px; padding: 35px 25px 25px 25px; display: flex; flex-direction: column; text-align: center; position: relative; }
      .fit-card.recommended { border: 1.5px solid #e2ba7d; background: #fef7ef; }
      .rec-label {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 11px;
    padding: 8px;
    color: #c5a059;
    border: 1px solid #ece1d1;
    background: #fdf1e8;
    font-weight: 600;
    border-radius: 0px 13px 0px 10px;
    letter-spacing: 0.5px;
}
      .card-content-wrapper { display: flex; flex-direction: column; flex-grow: 1; width: 100%; }
      .card-left { display: flex; flex-direction: column; align-items: center; width: 100%; }
      .card-right { display: flex; flex-direction: column; align-items: center; width: 100%; }
      
      .qty-display { font-family: 'Playfair Display', serif !important; font-size: 95px !important; color: #001b3a !important; margin: 0 !important; font-weight: 400 !important; }
      .card-label-top { font-size: 15px; font-weight: 700; color: #001b3a; text-transform: uppercase; letter-spacing: 1.5px; margin: 10px 0 10px 0; }
      .card-subtext { font-size: 14px; font-style: italic; color: #333; margin: -5px 0 10px 0; font-family: 'Playfair Display', serif; }
      
      .card-divider-desktop { height: 1px; background: #f0f0f0; width: 100%; margin: 15px 0; border: none; }
      .card-divider-mobile { display: none; width: 1px; background: #f0f0f0; align-self: stretch; margin: 0 20px; }
      
      .perks-area { width: 100%; display: flex; flex-direction: column; align-items: flex-start; text-align: left; }
      .green-promo { color: #225a2d; font-weight: 700; font-size: 15px; text-align: center; text-transform: uppercase; line-height: 1.4; width: 100%; }
      .box-info { background: #f8fbf8; border-radius: 6px; padding: 12px; display: flex; align-items: center; gap: 10px; font-size: 12px; font-weight: 700; color: #001b3a; width: 100%; }
      .box-info.warning { background: #fff7f2; }
      .box-info svg { width: 18px; height: 18px; flex-shrink: 0; }
      .list-item { display: flex; align-items: center; gap: 12px; font-size: 14px; color: #444; margin-bottom: 12px; }
      .list-item svg { width: 22px; height: 22px; flex-shrink: 0; stroke: #333; }
      
      .p-btn { width: 100%; padding: 16px; border-radius: 6px; font-weight: 700; font-size: 16px; text-transform: uppercase; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 15px; text-decoration: none; border: none; letter-spacing: 1px; transition: all 0.2s; margin-top: 15px; }
      .p-btn-orange { background: #bd5b0d; color: #fff; }
      .p-btn-navy { background: #32445a; color: #fff; }
      .p-btn-outline { background: #fff; color: #001b3a; border: 1px solid #001b3a; }
      .p-btn:hover { opacity: 0.9; }
      
      .fit-footer { background: #fdf6e9; padding: 15px; border-radius: 10px; display: flex; align-items: center; justify-content: center; gap: 12px; font-size: 15px; color: #222; font-weight: 500; font-style: italic; font-family: 'Playfair Display', serif; border: 1px solid #f2e6d5; }
      
      /* ================= MOBILE LAYOUT ================= */
      @media (max-width: 900px) {
        #fit-upsell-overlay { padding: 10px; align-items: flex-start; }
        #fit-modal-container { padding: 30px 15px 20px 15px; border-radius: 10px; margin-top: 10px; }
        
        /* Header Adjustments */
        .logo-wings { width: 90px; margin-bottom: 5px; }
        .fit-header h1 { font-size: 26px !important; letter-spacing: 2px; line-height: 1.2 !important; }
        .fit-header .sub-h1 { font-size: 22px !important; letter-spacing: 2px; }
        .trusted-row { font-size: 13px; margin-bottom: 15px; }
        .trusted-row::before, .trusted-row::after { width: 30px; }
        
        .fit-grid { flex-direction: column; gap: 15px; margin-bottom: 15px; }
        .fit-card { padding: 35px 20px 20px 20px; }
        
        /* Mobile Split Card Layout */
        .card-content-wrapper { flex-direction: row; align-items: center; }
        .card-left { width: 35%; flex-shrink: 0; align-items: center; justify-content: center; text-align: center; }
        .card-right { width: auto; flex-grow: 1; align-items: flex-start;}
        
        /* Swap Dividers */
        .card-divider-desktop { display: none; }
        .card-divider-mobile { display: block !important; margin: 0 15px; }
        
        /* Content Adjustments */
        .qty-display { font-size: 55px !important; }
        .card-label-top { font-size: 13px; line-height: 1.2; margin: 5px 0 2px 0; }
        .card-subtext { font-size: 12px; margin: 0; }
        
        .green-promo { text-align: left; font-size: 13px; margin-bottom: 10px; }
        .box-info { padding: 8px 10px; margin-bottom: 12px; font-size: 11px; }
        .list-item { font-size: 13px; margin-bottom: 8px; }
        .list-item svg { width: 18px; height: 18px; }
        
        .p-btn { padding: 14px; font-size: 14px; }
        .fit-footer { font-size: 13px; padding: 12px; flex-direction: row; text-align: left; line-height: 1.4; }
        .fit-footer svg { flex-shrink: 0; width: 28px; height: 28px; }
      }
    `;
    document.head.appendChild(style);
  };

  // ============== 3. RENDER FUNCTION ==============
  function showFitUpsell(quantity) {
    if (hasShownThisSession || quantity >= 3) return;

    const overlay = document.createElement("div");
    overlay.id = "fit-upsell-overlay";

    overlay.innerHTML = `
      <div id="fit-modal-container">
        <span class="fit-close">&times;</span>
        
        <div class="fit-header">
           ${ICONS.wings}
           <h1>Get The Perfect Fit</h1>
           <div class="sub-h1">No Guesswork</div>
           <div class="trusted-row">
             <span class="g-star">★</span> Trusted by Pilots Since 1991 <span class="g-star">★</span>
           </div>
        </div>

        <div class="fit-grid">
          
          <!-- CARD 1 -->
          <div class="fit-card recommended">
            <div class="rec-label">Recommended</div>
            
            <div class="card-content-wrapper">
              <div class="card-left">
                <h2 class="qty-display">3+</h2>
                <div class="card-label-top">Free Pilot Pants</div>
              </div>
              
              <div class="card-divider-mobile"></div>
              
              <div class="card-right">
                <hr class="card-divider-desktop">
                <div class="green-promo">FREE TRIAL FIT PANT<br><span style="font-weight:400; font-size:13px; color:#666; text-transform:none;">Included</span></div>
                <hr class="card-divider-desktop">               
                <div class="perks-area">
                  <div class="list-item">${ICONS.pants} Trial Fit Pant ships first</div>
                  <div class="list-item">${ICONS.truck} Free shipping included</div>
                </div>
              </div>
            </div>

            <button class="p-btn p-btn-orange" id="close-3">Get 3+ Pants ${ICONS.arrow}</button>
          </div>

          <!-- CARD 2 -->
          <div class="fit-card">
            <div class="card-content-wrapper">
              <div class="card-left">
                <h2 class="qty-display">2</h2>
                <div class="card-label-top">Pilot Pants</div>
                <div class="card-subtext">with Trial Fit Pant</div>
              </div>

              <div class="card-divider-mobile"></div>

              <div class="card-right">
                <div class="box-info">
                    ${ICONS.tag}
                    <span style="color: #225a2d;">ADD TRIAL FIT PANT – $49.99</span>
                </div>
                <hr class="card-divider-desktop">
                <div class="perks-area">
                  <div class="list-item">${ICONS.pants} Trial Fit Pant ships first</div>
                  <div class="list-item">${ICONS.truck} Free shipping included</div>
                </div>
              </div>
            </div>

            <button class="p-btn p-btn-navy" id="add-trial">Add Trial Fit Pant – $49.99 ${ICONS.arrow}</button>
          </div>

          <!-- CARD 3 -->
          <div class="fit-card">
            <div class="card-content-wrapper">
              <div class="card-left">
                <h2 class="qty-display">1-2</h2>
                <div class="card-label-top">Pilot Pants</div>
                <div class="card-subtext">Direct Production</div>
              </div>

              <div class="card-divider-mobile"></div>

              <div class="card-right">
                <div class="box-info warning">
                    ${ICONS.warn}
                    <div style="text-align:left; font-size:12px; line-height:1.3; font-family:'Playfair Display', serif; color:#001b3a;">No Trial Fit Pant.<br><span style="font-weight:400; opacity:0.8; font-family:'Inter', sans-serif;">All pants produced and shipped together.</span></div>
                </div>
                <hr class="card-divider-desktop">
                <div class="perks-area">
                  <div class="list-item" style="margin-top:5px;">${ICONS.truck} Shipping charges may apply</div>
                </div>
              </div>
            </div>

            <button class="p-btn p-btn-outline" id="close-cont">Continue ${ICONS.arrow}</button>
          </div>

        </div>

        <div class="fit-footer">
           ${ICONS.shield} <div>Trial Fit Pant confirms your fit before final production.</div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    // Event Listeners
    const exit = () => { overlay.remove(); hasShownThisSession = true; };
    overlay.querySelector(".fit-close").onclick = exit;
    overlay.querySelector("#close-3").onclick = exit;
    overlay.querySelector("#close-cont").onclick = exit;

    overlay.querySelector("#add-trial").onclick = (e) => {
      e.preventDefault();
      exit();
      const target = document.querySelector('.add-more-pant');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    overlay.onclick = (e) => { if (e.target === overlay) exit(); };
  }

  // ============== 4. INITIALIZE ==============
  setupDependencies();

  setTimeout(() => {
    const wrapper = document.querySelector("div.ymq-option-qb-wrapper");
    if (!wrapper) return;
    wrapper.addEventListener("click", (e) => {
      const input = e.target.closest("input.ymq-option-qb-input");
      if (input) showFitUpsell(parseInt(input.value, 10));
    });
  }, 2000);
});